import classNames from "classnames/bind";
import React, { PropsWithChildren, forwardRef, useState } from "react";
import { Popover } from "react-tiny-popover";
import Button from "../Button/Button";
import styles from "./ButtonWithPopover.module.scss";
import { ButtonWithPopoverProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A button with a popover attached to it
 */
export const ButtonWithPopover = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonWithPopoverProps>
>(
  (
    {
      children,
      label,
      buttonProps,
      popoverProps,
      style,
      ...restProps
    }: PropsWithChildren<ButtonWithPopoverProps>,
    ref
  ) => {
    const [open, setOpen] = useState(false);

    return (
      <Popover
        positions={["bottom", "right", "left"]}
        align="center"
        padding={2}
        {...popoverProps}
        content={() => <p className={cx("label")}>{label}</p>}
        containerClassName={cx("popover")}
        isOpen={open}
      >
        <div
          className={cx("actionContainer")}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          style={style}
        >
          <Button
            ref={ref}
            size="small"
            iconProps={{ size: 18 }}
            variant="outline"
            {...buttonProps}
            {...restProps}
          >
            {children}
          </Button>
        </div>
      </Popover>
    );
  }
);

ButtonWithPopover.displayName = "ButtonWithPopover";
